"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledInput = styled_components_1.default.div `
	position: relative;
	width: 100%;

	label {
		left: 40px;
		margin-bottom: 5px;
		width: 20vw;
		font-size: ${({ theme, customStyle }) => { var _a, _b; return `${((_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontSize) || theme.smallFontSize}`; }};
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.gray3; }};
	}

	span {
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.gray3; }};
	}

	&:focus-within {
		border-bottom-color: ${({ theme }) => `${theme.denimBlue}`};
	}

	display: flex;
	align-items: center;
	justify-items: center;
	margin-top: 25px;
	width: ${({ width }) => width ? width : 'inherit'};

	@media (max-width: 41em) {
		margin-left: 20px;
		margin-right: 20px;
	}

	@media (max-width: 260px) {
		margin-left: 10px;
		margin-right: 10px;
		label {
			left: 0;
		}
	}

	&.invalid {
		input {
			border: ${({ theme, customStyle }) => { var _a, _b; return `2px solid ${(_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : theme.invalidRed}`; }};
		}
	}

	.icon-span {
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.gray3; }};
		margin-bottom: 5px;
		margin-right: 5px;
		width: 15px;
	}

	input, textarea {
		border: ${({ theme }) => `1px solid ${theme.gray3}`};
		height: 30px;
		width: ${({ width }) => (width ? width : '100%')};
		font-size: ${({ theme, customStyle }) => { var _a, _b; return `${((_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontSize) || theme.baseFontSize}`; }};
		text-align: left;
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.black; }};
		background-color: white;

		&:focus {
			outline: none;
		}
	}

	div {
		text-align: left;
	}
`;
exports.Input = react_1.default.forwardRef((props, ref) => {
    const { name, className, type, width, icon, placeholder, dataTestId, maxLength, maxLengthLabel, minLength, value, onChange, ariaDescribedBy, ariaRequired, ariaInvalid, hintElement, id, hideIcon, hideLabel, loaded, isTextarea, customStyle } = props, rest = __rest(props, ["name", "className", "type", "width", "icon", "placeholder", "dataTestId", "maxLength", "maxLengthLabel", "minLength", "value", "onChange", "ariaDescribedBy", "ariaRequired", "ariaInvalid", "hintElement", "id", "hideIcon", "hideLabel", "loaded", "isTextarea", "customStyle"]);
    const inputRef = react_1.useRef();
    react_1.useImperativeHandle(ref, () => ({
        // @ts-ignore
        focus: () => inputRef.current.focus()
    }));
    return (react_1.default.createElement(StyledInput, { className: className, hideIcon: hideIcon, width: width, customStyle: customStyle },
        react_1.default.createElement("div", null,
            hideIcon ? null :
                react_1.default.createElement("span", { className: "icon-span", "data-testid": "input-icon" }, icon),
            hintElement,
            hideLabel ? null :
                react_1.default.createElement("label", { htmlFor: id, "data-testid": "input-label" },
                    placeholder,
                    maxLength && react_1.default.createElement("span", { id: `${id}-format` }, maxLengthLabel),
                    ariaRequired && react_1.default.createElement("span", { "aria-hidden": 'true' }, " *")),
            isTextarea ? (react_1.default.createElement("textarea", Object.assign({ id: id, name: name, width: width, "data-testid": dataTestId, maxLength: maxLength, minLength: minLength, value: value, onChange: onChange, "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy, "aria-required": ariaRequired, 
                // @ts-ignore
                ref: inputRef }, rest))) : (react_1.default.createElement("input", Object.assign({ id: id, name: name, type: type ? type : 'text', width: width, "data-testid": dataTestId, maxLength: maxLength, minLength: minLength, value: value, onChange: onChange, "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy, "aria-required": ariaRequired, 
                // @ts-ignore
                ref: inputRef, placeholder: ariaRequired ? `${placeholder}*` : placeholder }, rest))))));
});
